import { DiscoverList } from '../components';
import { DiscoverListTabEnum } from '../components/discover-list';

const DiscoverAll = () => {
  return <DiscoverList tab={DiscoverListTabEnum.All} />;
};

export default DiscoverAll;
